import { useQuery } from '@tanstack/react-query';
import { getUserPermissions } from 'services/config/getUserPermissions';

export const userPermissionsQueryKey = ['userPermissions'] as const;

export const useUserPermissions = () =>
  useQuery({
    queryKey: userPermissionsQueryKey,
    queryFn: getUserPermissions,
    staleTime: Infinity, // session-scoped fact - never needs refetching once loaded
  });
